export enum EProviderType {
    COOKIES_ANALITICAS      = 1,
    COOKIES_SOCIALES        = 2,
    COOKIES_AFILIADOS       = 3,
    COOKIES_PUBLICITARIAS   = 4,
    COOKIES_FUNCIONALES     = 5,
}

export enum TAnalyticProvider {
    GA4     = 'ga4',
    ANDROID = 'android',
    IOS     = 'ios',
}

export enum TConsentModeMode {
    GPT     = 'gpt',
    ANDROID = 'android',
    IOS     = 'ios',
    GTAG    = 'gtag',
}
